import React from 'react';

import Background from '../../components/UI/Background/Background';

import StartingPageContent from '../components/StartingPage/StartingPageContent';

const HomePage = () => {
  return <>
    <Background />
    <StartingPageContent />
  </>;
};

export default HomePage;
